var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2291 5.02344C28.0562 5.04168 26.9088 5.36912 25.9029 5.97268C24.8969 6.57624 24.0681 7.43455 23.5 8.46094C22.9319 7.43455 22.103 6.57624 21.0971 5.97268C20.0912 5.36912 18.9438 5.04168 17.7708 5.02344C15.901 5.10468 14.1393 5.92266 12.8706 7.29868C11.6019 8.6747 10.9294 10.4969 11 12.3672C11 17.1036 15.9854 22.2766 20.1666 25.7839C21.1002 26.5684 22.2806 26.9985 23.5 26.9985C24.7194 26.9985 25.8997 26.5684 26.8333 25.7839C31.0146 22.2766 36 17.1036 36 12.3672C36.0705 10.4969 35.398 8.6747 34.1294 7.29868C32.8607 5.92266 31.099 5.10468 29.2291 5.02344Z",
    fill: "#7131FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdii_208_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2342 2.02734C22.0612 2.04559 20.9139 2.37302 19.9079 2.97658C18.902 3.58014 18.0731 4.43846 17.505 5.46484C16.937 4.43846 16.1081 3.58014 15.1022 2.97658C14.0962 2.37302 12.9488 2.04559 11.7759 2.02734C9.90602 2.10858 8.14432 2.92657 6.87565 4.30259C5.60698 5.67861 4.93447 7.50081 5.00504 9.37109C5.00504 14.1076 9.99046 19.2805 14.1717 22.7878C15.1053 23.5723 16.2856 24.0024 17.505 24.0024C18.7245 24.0024 19.9048 23.5723 20.8384 22.7878C25.0196 19.2805 30.005 14.1076 30.005 9.37109C30.0756 7.50081 29.4031 5.67861 28.1344 4.30259C26.8658 2.92657 25.1041 2.10858 23.2342 2.02734Z",
    fill: "#7131FB",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdii_208_242",
    x: -40,
    y: -42.9727,
    width: 115.01,
    height: 111.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 22.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_208_242"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_208_242",
    result: "effect2_dropShadow_208_242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_208_242",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_208_242"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_208_242",
    result: "effect4_innerShadow_208_242"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartsIcon);
export default __webpack_public_path__ + "static/media/hearts_icon.9974f1f05e4b7c41f95bc9bbbc397793.svg";
export { ForwardRef as ReactComponent };